import { CSS } from "../../constants/css";
import { computePosition, shift, autoUpdate, Placement } from "@floating-ui/dom";

const tryToKeepInViewport = ($toggleBtn: HTMLElement, $content: HTMLElement, placement: Placement) => {
  const updatePosition = () => {
    computePosition($toggleBtn, $content, {
      placement: placement,
      middleware: [shift()],
    }).then(({ x, y }) => {
      Object.assign($content.style, {
        left: `${x}px`,
        top: `${y}px`,
      });
    });
  };

  autoUpdate($toggleBtn, $content, updatePosition);
};

const toggle = ($toggleBtn: HTMLElement, $content: HTMLElement) => {
  const isExpanded = $toggleBtn?.getAttribute("aria-expanded") === "true";
  const newState = (!isExpanded).toString();
  $content?.classList.toggle(CSS.active);
  $toggleBtn?.classList.toggle(CSS.active);
  $toggleBtn?.setAttribute("aria-expanded", newState);
};

const bindToggle = ($toggleBtn: HTMLElement, $content: HTMLElement) => {
  $toggleBtn?.addEventListener("click", () => toggle($toggleBtn, $content));
};

const instance = ($el: HTMLElement) => {
  const $toggleBtn = $el.querySelector<HTMLElement>(".js-dropdown-toggle");
  const $content = $el.querySelector<HTMLElement>(".js-dropdown-content");

  if (!$toggleBtn || !$content) {
    return;
  }

  if ($content.classList.contains("js-keep-in-viewport")) {
    const getPlacement = ($content: HTMLElement): Placement => {
      const placement = $content.getAttribute("js-placement");
      return placement as Placement || "bottom";
    };

    const placement = getPlacement($content);

    tryToKeepInViewport($toggleBtn, $content, placement);
  }

  // Remove .is-active class when an anchor link inside $content is clicked
  $content.querySelectorAll<HTMLAnchorElement>("a").forEach(($anchor) => {
    $anchor.addEventListener("click", () => {
      $content.classList.remove(CSS.active);
      $toggleBtn.classList.remove(CSS.active);
      $toggleBtn.setAttribute("aria-expanded", "false");
    });
  });

  bindToggle($toggleBtn, $content);
};

export default () => {
  const $dropdowns = document.querySelectorAll<HTMLElement>(".js-dropdown");
  $dropdowns.forEach((dropdown) => {
    instance(dropdown);
  });
};
